import { I18n } from "aws-amplify";

// https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/i18n/dictionaries/authenticator/es.ts
const spanish = {
    'Sign in': 'Iniciar sesión',
    'Sign in to your account': 'Welcome Back!',
    Email: 'Correo electrónico',
    Password: 'Contraseña',
    'Forgot your password?': '¿Olvidaste tu contraseña?',
    'Reset Password': 'Restablecer contraseña',
    'Enter your email': 'Introduce tu correo electrónico',
    'Enter your Email': 'Introduce tu correo electrónico',
    'Enter your Password': 'Introduce tu contraseña',
    "Enter your Confirmation Code": "Introduce tu código de confirmación",
    'Send code': 'Enviar codigo',
    'Back to Sign In': 'Volver',
    Sending: "Enviando",
    'Code *': 'Codigo',
    'Code': 'Introduce el codigo',
    'New Password': 'Nueva contraseña',
    'Confirm Password': 'Confirmar contraseña',
    Submit: 'Enviar',
    Submitting: 'Enviando',
    'Resend Code': 'Reenviar codigo',
    'Signing in': 'Iniciando sesión',
    'User does not exist.': 'El usuario no existe.',
    'Change Password': 'Cambiar contraseña',
    Changing: 'Cambiando',
    'Please confirm your Password': 'Confirme su contraseña',
    'Invalid password format': 'Formato de contraseña inválido',
    'Your passwords must match': 'Tus contraseñas deben coincidir.',
    'Incorrect username or password.': 'Nombre de usuario o contraseña incorrectos.',
    'Password must have at least 8 characters':
        'La contraseña debe tener al menos 8 caracteres',
    'Password did not conform with policy: Password must have uppercase characters':
        'La contraseña debe tener al menos un carácter en mayúscula',
    'Password did not conform with policy: Password must have numeric characters':
        'La contraseña debe tener al menos un carácter numérico',
    'Password did not conform with policy: Password must have symbol characters':
        'La contraseña debe tener al menos un símbolo',
    'Password did not conform with policy: Password must have lowercase characters':
        'La contraseña debe tener al menos un carácter en minúsculas',
    'Invalid verification code provided, please try again.':
        'Código de verificación no válido, inténtelo de nuevo.',
    'Attempt limit exceeded, please try after some time.':
        'Número máximo de intentos excedido, por favor inténtelo de nuevo más tarde.',
    'A network error has occurred.': 'Se ha producido un error de red.',
};

I18n.putVocabulariesForLanguage("es", spanish);